import { fetchWithTimeout } from './fetchWithTimeout';

export type Attachment = {
    attachmentId?: string;
    questionnaireFormId?: string;
    originalname?: string;
    fieldname?: string;
    encoding?: string;
    mimetype?: string;
    destination?: string;
    filename?: string;
    path?: string;
    size?: number;
    createBy?: string;
    createDate?: Date;
    updateBy?: string;
    updateDate?: Date;
};

type UploadSingleFileRequestData = { attachmentId?: string; questionnaireFormId: string; originalname?: string; file: File };

function uploadSingleFile(data: UploadSingleFileRequestData) {
    const formData = new FormData();
    data.attachmentId && formData.append('attachmentId', data.attachmentId);
    formData.append('questionnaireFormId', data.questionnaireFormId!);
    data.originalname && formData.append('originalname', data.originalname);
    formData.append('file', data.file);
    return fetchWithTimeout('attachment/uploadSingleFile', {
        method: 'POST',
        body: formData,
    })
        .then((res) => res)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

type GetSingleFileRequestData = { attachmentId: string };

function getSingleFile(data: GetSingleFileRequestData) {
    return fetchWithTimeout('attachment/getSingleFile', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

// type CreateRequestData = Attachment & {};

// type CreateResponseData = {
//     statusCode: number;
//     message: string;
//     success: boolean;
//     data?: Attachment;
// };

// function create(data: CreateRequestData) {
//     return fetchWithTimeout('attachment/create', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(data),
//     })
//         .then((res) => res.json())
//         .then((data: CreateResponseData) => data)
//         .catch((error) => {
//             throw error;
//         })
//         .finally(() => {});
// }

// type CreateBulkResponseData = {
//     statusCode: number;
//     message: string;
//     success: boolean;
//     data?: Attachment[];
// };

// function createBulk(data: CreateRequestData[]) {
//     return fetchWithTimeout('attachment/createBulk', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(data),
//     })
//         .then((res) => res.json())
//         .then((data: CreateBulkResponseData) => data)
//         .catch((error) => {
//             throw error;
//         })
//         .finally(() => {});
// }

type GetRequestData = Attachment & {
    attachmentIdIn?: string[];
    select?: (keyof Attachment)[];
    loadEagerRelations?: boolean;
};

type GetResponseData = {
    statusCode: number;
    message: string;
    success: boolean;
    data?: Attachment[];
};

function get(data: GetRequestData) {
    return fetchWithTimeout('attachment/get', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((data: GetResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

// type UpdateRequestData = Attachment & { attachmentId: string };

// type UpdateResponseData = {
//     statusCode: number;
//     message: string;
//     success: boolean;
//     data?: Attachment;
// };

// function update(data: UpdateRequestData) {
//     return fetchWithTimeout('attachment/update', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(data),
//     })
//         .then((res) => res.json())
//         .then((data: UpdateResponseData) => data)
//         .catch((error) => {
//             throw error;
//         })
//         .finally(() => {});
// }

// type UpdateBulkResponseData = {
//     statusCode: number;
//     message: string;
//     success: boolean;
//     data?: Attachment[];
// };

// function updateBulk(data: UpdateRequestData[]) {
//     return fetchWithTimeout('attachment/updateBulk', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(data),
//     })
//         .then((res) => res.json())
//         .then((data: UpdateBulkResponseData) => data)
//         .catch((error) => {
//             throw error;
//         })
//         .finally(() => {});
// }

type RemoveRequestData = Attachment & {};

type RemoveResponseData = {
    statusCode: number;
    message: string;
    success: boolean;
    data?: {};
};

function remove(data: RemoveRequestData) {
    return fetchWithTimeout('attachment/remove', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((data: RemoveResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

// function removeBulk(data: RemoveRequestData[]) {
//     return fetchWithTimeout('attachment/removeBulk', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(data),
//     })
//         .then((res) => res.json())
//         .then((data: RemoveResponseData) => data)
//         .catch((error) => {
//             throw error;
//         })
//         .finally(() => {});
// }

export default { uploadSingleFile, getSingleFile, /*create, createBulk, */ get, /*update, updateBulk,*/ remove /*removeBulk*/ };
